import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { type DeleteReservationTypeDTO } from 'src/features/reservations/hooks/useDeleteReservationType.ts';
import { reservationMessages } from 'src/features/reservations/utils/messages.ts';
import SquareIcon from 'src/registry/components/blocks/SquareIcon.tsx';
import { Button } from 'src/registry/ui/Button.tsx';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
} from 'src/registry/ui/Dialog.tsx';
import { generalMessages } from 'src/utils/messages.ts';

import type { ReservationType } from 'src/features/reservations/types/reservationType.ts';

type DeleteVersionProps = {
    isDeleteVersionModalOpen: boolean;
    closeDeleteVersionModal: (isOpen: boolean) => void;
    deleteVersion: ({ versionId, parkingId }: DeleteReservationTypeDTO) => void;
    selectedVersion: ReservationType;
};

const DeleteVersion = ({
    isDeleteVersionModalOpen,
    closeDeleteVersionModal,
    selectedVersion,
    deleteVersion,
}: DeleteVersionProps) => {
    const { formatMessage } = useIntl();
    const { parkingId } = useParams();

    const versionName = selectedVersion.name;

    return (
        <Dialog open={isDeleteVersionModalOpen} onOpenChange={closeDeleteVersionModal}>
            <DialogContent>
                <DialogHeader>
                    <div className="flex gap-2">
                        <SquareIcon icon={faTrashAlt} />
                        <div>
                            <DialogTitle>{formatMessage(reservationMessages.deleteVersion)}</DialogTitle>
                            <DialogDescription>{`${formatMessage(reservationMessages.deleteVersion)} ${versionName}`}</DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody>
                    <p className="text-gray-500">
                        {formatMessage(reservationMessages.confirmDeleteVersion, { versionName })}
                    </p>
                </DialogBody>
                <DialogSeparator />
                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="outline" type="button" className="flex-1">
                            {formatMessage(generalMessages.cancel)}
                        </Button>
                    </DialogClose>
                    <Button
                        variant="destructiveLight"
                        onClick={() => {
                            if (selectedVersion) {
                                return (
                                    deleteVersion({ versionId: selectedVersion.id, parkingId: parkingId || '' }),
                                    closeDeleteVersionModal(!isDeleteVersionModalOpen)
                                );
                            }
                        }}
                        className="flex-1"
                    >
                        {formatMessage(reservationMessages.deleteVersion)}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteVersion;
